/**
 * CSRF Token 管理
 *
 * 提供 CSRF Token 的生成、儲存和取得功能
 */

import { generateCsrfToken, SECURITY_CONSTANTS } from './security';

/**
 * 初始化 CSRF Token
 * 如果不存在則生成新的 token
 */
export function initCsrfToken(): void {
  const existingToken = getCsrfToken();
  if (!existingToken) {
    const newToken = generateCsrfToken();
    localStorage.setItem(SECURITY_CONSTANTS.CSRF_TOKEN_KEY, newToken);
  }
}

/**
 * 取得 CSRF Token
 */
export function getCsrfToken(): string | null {
  return localStorage.getItem(SECURITY_CONSTANTS.CSRF_TOKEN_KEY);
}

/**
 * 重新生成 CSRF Token
 */
export function refreshCsrfToken(): string {
  const newToken = generateCsrfToken();
  localStorage.setItem(SECURITY_CONSTANTS.CSRF_TOKEN_KEY, newToken);
  return newToken;
}

/**
 * 清除 CSRF Token
 */
export function clearCsrfToken(): void {
  localStorage.removeItem(SECURITY_CONSTANTS.CSRF_TOKEN_KEY);
}

/**
 * 驗證 CSRF Token（前端驗證，真正的驗證在後端）
 */
export function validateCsrfToken(token: string | null): boolean {
  if (!token) {
    return false;
  }
  const storedToken = getCsrfToken();
  return token === storedToken;
}
